import ToastEnums from '../components/Toast/ToastEnums';

export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';

export function addToast(toast) {
    return dispatch => {
        dispatch({type: ADD_TOAST, toast});
    };
}

export function removeToast(toast) {
    return dispatch => {
        dispatch({type: REMOVE_TOAST, toast})
    };
}

export function showToastForBackend(error) {
    const toast = {
        toastType: ToastEnums.ERROR,
        message: error.error,
        ...error
    };

    if (toast && toast.message && toast.message.includes("Please log in again")) {
        setTimeout(() => {
            localStorage.removeItem("user")
            localStorage.removeItem("token")
            window.location.href = "/"
        }, 3000)
    }

    return dispatch => {
        dispatch({type: ADD_TOAST, toast});
    };
}

export function showToastForFrontend(messageCode) {
    const toast = messageCode;

    return dispatch => {
        dispatch({type: ADD_TOAST, toast});
        setTimeout(() => dispatch({type: REMOVE_TOAST, toast}), 5000);
    };
}
